import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import WorkDetails from '@/views/WorkDetails.vue'
import OnlineAccountRegistration from '@/views/Portfolio/OnlineAccountRegistration.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior() {
    // always scroll to top
    return { x: 0, y:0}
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/details/:id',
      name: 'WorkDetails',
      component: WorkDetails,
      props: true,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js